import Route from 'route-parser'
import Icon from 'components/shared/Icon'
import { MAILTO } from 'constants/urls'

const mailParser = new Route(MAILTO)

const subject = 'FromCounsel - Shared content (Documents)'

export default function EmailLink ({ shareUrl }: { shareUrl: string }): JSX.Element {
  const body = `A colleague has shared some FromCounsel (Documents) content with you: ${shareUrl}`
  const emailLink = 'mailto:' + (mailParser.reverse({ subject, body }) as string).replace('#', '%23')

  return (
    <a className='hs8 w8 br2 precedents-blue hover-bg-ghost-white flex justify-center items-center' href={emailLink} target='_blank' rel='noopener noreferrer'>
      <Icon name='icon-email-outline' className='hs7 w7' />
    </a>
  )
}
